import { Pipe, PipeTransform } from '@angular/core';
import { OrgTreeNodeModelRunScenarioType } from 'app/viewmodels/analysis/org-tree-node-model-run';

@Pipe({
  name: 'scenarioType',
})
export class ScenarioTypePipe implements PipeTransform {
  transform(value: OrgTreeNodeModelRunScenarioType): string {
    switch (value) {
    case OrgTreeNodeModelRunScenarioType.Driving:
      return 'Driving';
    case OrgTreeNodeModelRunScenarioType.WhatIf:
      return 'What-If';
    case OrgTreeNodeModelRunScenarioType.DrivingHistorical:
      return 'Driving (Historical)';
    default:
      return 'Unknown';
    }
  }
}
